export default __webpack_public_path__ + "static/char-s-29-ko-8819e5be7e84a3d80ce94e7256963284.png";